"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonCircular = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const common_1 = require("../Styled/common");
exports.ButtonCircular = react_1.forwardRef((_a, ref) => {
    var { id, className, buttonCursorCustomClassName, type, children, disabled, variant = 'basic', greyIcon, size = 'medium', name, ariaLabel, ariaLabelledBy, ariaDescribedBy, ariaControls, ariaPressed, ariaExpanded, ariaHasPopup, margin, marginX, marginY, marginRight, marginLeft, marginTop, marginBottom, zIndex = 'surface-base' } = _a, restProps = __rest(_a, ["id", "className", "buttonCursorCustomClassName", "type", "children", "disabled", "variant", "greyIcon", "size", "name", "ariaLabel", "ariaLabelledBy", "ariaDescribedBy", "ariaControls", "ariaPressed", "ariaExpanded", "ariaHasPopup", "margin", "marginX", "marginY", "marginRight", "marginLeft", "marginTop", "marginBottom", "zIndex"]);
    const buttonCursorBaseClassName = 'bds-c-btn-cursor';
    const buttonCursorDisabledClassName = disabled ? `bds-is-disabled` : '';
    const buttonCursorMarginClassNames = common_1.mapMarginPropsToClassName({
        margin,
        marginX,
        marginY,
        marginRight,
        marginLeft,
        marginTop,
        marginBottom
    });
    const buttonCursorClassName = classnames_1.default(buttonCursorBaseClassName, buttonCursorDisabledClassName, buttonCursorMarginClassNames, buttonCursorCustomClassName);
    const buttonBaseClassName = 'bds-c-btn';
    const buttonCircularBaseClassName = 'bds-c-btn-circular';
    const buttonCircularVariantClassName = variant
        ? `${buttonCircularBaseClassName}-${variant}`
        : '';
    const buttonCircularGreyIconClassName = greyIcon
        ? `${buttonCircularBaseClassName}--grey-icon`
        : '';
    const buttonCircularSizeClassName = size
        ? `${buttonCircularBaseClassName}--size-${size}`
        : '';
    const buttonCircularZIndexClassName = common_1.mapZindexPropstoClassName({
        zIndex
    });
    const buttonCircularClassName = classnames_1.default(buttonBaseClassName, buttonCircularBaseClassName, buttonCircularVariantClassName, buttonCircularGreyIconClassName, buttonCircularSizeClassName, buttonCircularZIndexClassName, className);
    return (react_1.default.createElement("div", { className: buttonCursorClassName },
        react_1.default.createElement("button", Object.assign({ id: id, className: buttonCircularClassName, type: type, disabled: disabled, ref: ref, name: name, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, "aria-controls": ariaControls, "aria-pressed": ariaPressed, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup }, restProps), children)));
});
exports.ButtonCircular.displayName = 'ButtonCircular';
exports.default = exports.ButtonCircular;
